import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main, // 네비게이션 바 색상과 동일
        color: theme.palette.primary.contrastText, // 텍스트 색상
        py: 2, // 상하 패딩
        textAlign: 'center',
        width: '100%',
        mt: 'auto', // 페이지 하단에 고정
      }}
    >
      <Typography variant="body2">
        © 2025 ADS Lab. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
